/**
 * ChartSection - 共享的图表渲染组件
 * @description Games 和 TopPublishersV2 复用的 Bar/Pie/Line 条件渲染
 */
import React from 'react';
import Loading from '@intelligence/components/Loading';
import NoData from '@intelligence/components/NoData';
import { BarChart, LineChart, PieChart } from '@intelligence/v3/components/ChartComponents';
import { isEmpty } from '@intelligence/v3/utils/common';
import { ChartType } from '@intelligence/v3/enums/chart';
import { LANGUAGE_EN } from '@home/_config/config';

interface IChartSectionProps extends IBaseProps {
  lineLoading?: boolean;
  height?: number;
  chartType: ChartType;
  metricName: string;
  barChartData: any[];
  pieChartData: any[];
  lineChartData: any[];
  barTooltipFormatter: (params: any[]) => string;
  pieTooltipFormatter: (param: any) => string;
  lineTooltipFormatter: (params: any[]) => string;
  xAxisLabelFormatter: (value: string) => string;
}

const ChartSection: React.FC<IChartSectionProps> = (props) => {
  const {
    style,
    locale,
    lineLoading = false,
    height = 300,
    chartType,
    metricName,
    barChartData,
    pieChartData,
    lineChartData,
    barTooltipFormatter,
    pieTooltipFormatter,
    lineTooltipFormatter,
    xAxisLabelFormatter,
  } = props;

  const chartLocale = (locale || LANGUAGE_EN) as any;

  return (
    <div style={{ height, ...style }}>
      {chartType === ChartType.Bar && !isEmpty(barChartData) && (
        <BarChart
          locale={chartLocale}
          loading={false}
          data={barChartData}
          metricName={metricName}
          tooltipFormatter={barTooltipFormatter}
          showLabel={false}
        />
      )}
      {chartType === ChartType.Pie && !isEmpty(pieChartData) && (
        <PieChart
          locale={chartLocale}
          loading={false}
          data={pieChartData}
          metricName={metricName}
          tooltipFormatter={pieTooltipFormatter}
          showLabel={false}
        />
      )}
      {(chartType === ChartType.Line || !chartType) &&
        (lineLoading ? (
          <Loading style={{ height }} />
        ) : !isEmpty(lineChartData) ? (
          <LineChart
            locale={chartLocale}
            loading={false}
            gridLineStyle="dashed"
            data={lineChartData}
            tooltipFormatter={lineTooltipFormatter}
            xAxisLabelFormatter={xAxisLabelFormatter}
          />
        ) : (
          <NoData style={{ height }} />
        ))}
      {chartType === ChartType.Bar && isEmpty(barChartData) && <NoData style={{ height }} />}
      {chartType === ChartType.Pie && isEmpty(pieChartData) && <NoData style={{ height }} />}
    </div>
  );
};

export default ChartSection;
